import { Close } from "@mui/icons-material";
import { Box, Dialog, IconButton } from "@mui/material";

interface ImagePreviewDialogProps {
  open: boolean;
  src?: string;
  alt?: string;
  onClose: () => void;
}

export default function ImagePreviewDialog({ open, src, alt, onClose }: Readonly<ImagePreviewDialogProps>) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      slotProps={{ paper: { sx: { bgcolor: "transparent", boxShadow: "none", overflow: "visible" } } }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -16,
          right: -16,
          bgcolor: "background.paper",
          "&:hover": { bgcolor: "background.paper" },
        }}
      >
        <Close />
      </IconButton>
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{ maxWidth: "100%", maxHeight: "90vh", objectFit: "contain", display: "block", borderRadius: 1 }}
      />
    </Dialog>
  );
}